/**
 * example message:
 * Ratchet bracket:
{
	"messageType": "alertNotification",
	"notificationId": 1645480481907,
	"notificationDetails": {"updateType":"EXIT_TRIGGERED","notificationType":"TRADE_PLAN_UPDATE","TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "TACTIC_TRIGGERED",
	"statusDetails": {"pluginTemplate":{"stopDollars":2.0},"triggerPrice":100.0,"tradeDirection":"LONG","tacticName":"RATCHET_BRACKET","symbol":"XYZ"},
	"date": "2022-02-21T16:54:42.750-0500",
	"timestamp": "1645480482757"
}

 * @param {*} pluginTemplate 
 * @returns object with fields:
 * 1) stopCents ($ amount, like $1.1)
 */
export function ratchetBracketParser(pluginTemplate) {
    const parsedObject = {
        stopCents: null
    }
    if(pluginTemplate) {
        parsedObject.stopCents=pluginTemplate.stopCents;
    }
    return parsedObject;
}